export interface Notification {
  id: number
  type: 'success' | 'error' | 'info' | 'warning'
  message: string
}

const notifications = ref<Notification[]>([])
export function useNotifications() {
  let nextId = 0

  const notification = {
    success: (message: string, second: number | boolean) => {
      const id = nextId++
      notifications.value.push({ id, message, type: 'success' })
      if (typeof second == 'number') setTimeout(() => notification.remove(id), second * 1000)
    },
    info: (message: string, second: number | boolean) => {
      const id = nextId++
      notifications.value.push({ id, message, type: 'info' })
      if (typeof second == 'number') setTimeout(() => notification.remove(id), second * 1000)
    },
    warning: (message: string, second: number | boolean) => {
      const id = nextId++
      notifications.value.push({ id, message, type: 'warning' })
      if (typeof second == 'number') setTimeout(() => notification.remove(id), second * 1000)
    },
    error: (message: string, second: number | boolean) => {
      const id = nextId++
      notifications.value.push({ id, message, type: 'error' })
      if (typeof second == 'number') setTimeout(() => notification.remove(id), second * 1000)
    },


    remove: (id: number) => {
      const index = notifications.value.findIndex(n => n.id === id)
      if (index !== -1) notifications.value.splice(index, 1)
    }
  }

  return { notifications, notification }
}